import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import _ from 'lodash';
import { dp } from '../../../utils/shared.js';

class DenverSlideshow extends Component {

  constructor(props) {
    super(props);
    this.state = {
      slideshowIndex: 0
    };
    this._slideshowCycleSeconds = 0;
  }

  componentDidMount() {
    this._slideshowCycleSeconds = this.getCycleTime();
  }

  timedCycle = async () => {
    
    if (this.props.images.length <= 1) {
      return null;
    }
    this._slideshowCycleSeconds--;
    if (this._slideshowCycleSeconds < 1) {
      await this.cycleSlideshowIndex();
      this._slideshowCycleSeconds = this.getCycleTime(); 
    }
  }

  // Get the cycle time *for the current image*
  getCycleTime = () => {
    return this.props.cycleOverrides[this.state.slideshowIndex] || this.props.defaultCycleTime;
  };
  
  cycleSlideshowIndex = () => {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let slideshowIndex = 0;
        if (prevState.slideshowIndex < this.props.images.length - 1) {
          slideshowIndex = prevState.slideshowIndex + 1;
        }
        return { slideshowIndex };
      }, resolve);
    });
    
  }

  render() {
    let slideshowImage = this.props.images[this.state.slideshowIndex];
    let backgroundImage = 'none';
    if (slideshowImage) {
      const dpImage = dp(this.props.screen, slideshowImage, { path: '/img/ui/', file_name: 'image_default.png' });
      backgroundImage = `url(${dpImage})`;

    }
    return (
      <CSSTransitionGroup
        component='div'
        transitionName='slowfadedelay'
        transitionEnterTimeout={0}
        transitionLeaveTimeout={0}>
        <div key={this.props.images[this.state.slideshowIndex]}>
          <div style={{ left: this.props.screenOffset, backgroundImage: backgroundImage, backgroundSize: 'cover', position: 'absolute', height: this.props.height, width: this.props.width, top: 0 }}>

          </div>
        </div>
      </CSSTransitionGroup>
    )
  }
}

export default DenverSlideshow;


// WEBPACK FOOTER //
// ./src/Components/Theme/Denver/DenverSlideshow.js